module.exports = __webpack_public_path__ + "static/media/checklist.466630ac.svg";